import { getToken } from '@/utils/auth'
export const globalsMixin = {
  methods: {
    applyProductMIXIN(proId, path) {
      if (getToken() && this.$store.getters.userSourceType == '7') {
        if (!proId) return
        // path = '/demand/demandInsert?proId=' + proId
        path = `${path}?proId=${proId}`
        this.commonLinkMIXIN(path)
      } else if (getToken() && this.$store.getters.userSourceType != '7') {
        this.$message({
          message: '请登录企业用户申请金融产品',
          type: 'warning'
        });
      } else {
        this.$store.commit("user/setLoginDialogStatus", true);
      }


    },
    toReleaseMIXIN() {
      if (getToken() && this.$store.getters.userSourceType == '7') {
        const path = '/demand/demandInsert'
        this.commonLinkMIXIN(path)
      } else if (getToken() && this.$store.getters.userSourceType != '7') {
        this.$message({
          message: '请登录企业用户发布融资需求',
          type: 'warning'
        });
      } else {
        this.$store.commit("user/setLoginDialogStatus", true);
      }

    },
    toEquityFinancingAdd() {

      if (getToken() && this.$store.getters.userSourceType == '7') {
        const path = '/equityFinancing/add'
        this.commonLinkMIXIN(path)
      } else if (getToken() && this.$store.getters.userSourceType != '7') {
        this.$message({
          message: '请登录企业用户新建项目融资',
          type: 'warning'
        });
      } else {
        this.$store.commit("user/setLoginDialogStatus", true);
      }
    },
    consultFunMIXIN() {
      const path = '/advisory/advisoryForm'
      this.commonLinkMIXIN(path)
    },
    commonLinkMIXIN(path) {
      const certiFlg = this.$store.getters.certiFlg
      if (getToken()) {
        if ((certiFlg && certiFlg === '3') || this.$store.getters.userSourceType != '7') {
          const basUrl = this.$store.getters.protalUrl
          window.location.href = basUrl + path
        } else {
          this.$router.push({ path: "/authentication" });
        }
      } else {
        // 未登录弹窗
        this.$store.commit("user/setLoginDialogStatus", true);
      }
    },
    applyEquityMIXIN(id) {
      if (!id) return
      const path = '/equityFinancing/add?orgNo=' + id
      this.commonLinkMIXIN(path)
    },
    interviewMIXIN(id) {
      if (!id) return
      const roles = this.$store.getters.roles
      if (getToken()) {
        if (roles[0] === 'financeEquity') {
          const path = '/operation/detail?demandNo=' + id
          const basUrl = this.$store.getters.protalUrl
          window.location.href = basUrl + path
        }
      } else {
        // 未登录弹窗
        this.$store.commit('setLoginDialogStatus', true)
      }

    }
  },
  filters: {
    // 数据字典处理
    changeDic(value, data) {
      const tempData = data && data.find((_) => _.vkey === String(value))
      return (tempData && tempData.value) || '--'
    },
    // 产业字典处理
    changeIndustry(value, data) {
      const tempData = data && data.find((_) => _.code === value)
      return (tempData && tempData.codeText) || '--'
    },
    fixedNum(value) {
      return value && parseFloat(value).toFixed(2)
    },
    // 保留两位小数
    threeDecimal(value) {
      var f_x = parseFloat(value)
      if (isNaN(f_x)) {
        return 0
      }
      var f_x1 = Math.round(value * 1000) / 1000
      var s_x = f_x1.toString()
      var pos_decimal = s_x.indexOf('.')
      if (pos_decimal < 0) {
        pos_decimal = s_x.length
        s_x += '.'
      }
      while (s_x.length <= pos_decimal + 2) {
        s_x += '0'
      }
      return s_x
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/mixin.js